import { RouterTabOption } from 'lib/components/RouterTabs';
import { exists } from 'lib/types';
import { selectAvailableOrganizations, selectUser } from 'redux/auth';
import { useAppSelector } from 'redux/hooks';
import { PUB_REPORTS_ROUTES } from 'router/routes';
import {
  ShoppingBagIcon,
  UserGroupIcon,
  DocumentTextIcon,
  NewspaperIcon,
  BanknotesIcon
} from '@heroicons/react/24/outline';
import { OccupationType } from 'lib/enums';
import { wrapSuccess } from 'lib/types/responses';
import { Permissions } from 'lib/permissions/roles';
import { getRoleHasPermissionForAllAllowedOrganizationsForPublisherUser } from 'lib/frontend/utils/users';

export function useValidReportsTabs(): RouterTabOption[] {
  const availableOrganizations = useAppSelector(selectAvailableOrganizations);
  const user = useAppSelector(selectUser);

  if (availableOrganizations.length === 0 || !exists(user)) {
    return [];
  }

  const isPublisher =
    user.data().occupation === OccupationType.publishing.value;

  if (!isPublisher) {
    return [];
  }

  const [permissionSetError, permissionSet] =
    exists(user) && user.data().occupation === OccupationType.publishing.value
      ? getRoleHasPermissionForAllAllowedOrganizationsForPublisherUser(
          user,
          Permissions.PAYMENTS_REPORT
        )
      : wrapSuccess(new Set());

  const hasPaymentsReportPermission =
    !permissionSetError && permissionSet.size > 0;

  const tabs: RouterTabOption[] = [
    {
      path: PUB_REPORTS_ROUTES.PUBLIC_NOTICES,
      enabled: true,
      label: 'Public Notices',
      Icon: NewspaperIcon
    },
    {
      path: PUB_REPORTS_ROUTES.PRODUCTS,
      enabled: hasPaymentsReportPermission,
      label: 'Products',
      Icon: ShoppingBagIcon
    },
    {
      path: PUB_REPORTS_ROUTES.ACCOUNTING,
      enabled: hasPaymentsReportPermission,
      label: 'Accounting',
      Icon: BanknotesIcon
    },
    {
      path: PUB_REPORTS_ROUTES.CUSTOMERS,
      enabled: hasPaymentsReportPermission,
      label: 'Customers',
      Icon: UserGroupIcon
    },
    {
      path: PUB_REPORTS_ROUTES.PAGINATION,
      enabled: true,
      label: 'Pagination',
      Icon: DocumentTextIcon
    }
  ];

  return tabs;
}
